import React, { FC } from 'react';
import i18next from 'i18next';

import { LogoutButton, LogOutIcon, LogOutText } from '~src/modules/questions/components/mobileTongue.sc';
import { QuestionsAmount } from '~src/modules/questions/components/shared.sc';
import { routes } from '~src/routingConfig';

interface Props {
  t: i18next.TFunction;
}

const MobileLogoutButton: FC<Props> = React.memo(({ t }) => (
  <LogoutButton
    to={routes.logout}
    data-translation="x.sidebar.logout.tooltip.title"
    title={t('x.sidebar.logout.tooltip.title')}
  >
    <LogOutIcon name="iconExit" width={25} />
    <QuestionsAmount>
      <LogOutText data-translation="x.sidebar.logout.tooltip.title">
        {t('x.sidebar.logout.tooltip.title')}
      </LogOutText>
    </QuestionsAmount>
  </LogoutButton>
));

export default MobileLogoutButton;
